"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BellSchedulePeriodTimeCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const is_valid_time_decorator_1 = require("../shared/is-valid-time.decorator");
const is_valid_time_range_decorator_1 = require("../shared/is-valid-time-range.decorator");
class BellSchedulePeriodTimeCreateDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return ['start', 'end', 'bellSchedulePeriodId', 'bellScheduleId'];
    }
    mapFields(source, skipNested = false, skipTransforms = false) {
        super.mapFields(source, skipNested, skipTransforms);
        return this;
    }
    start;
    end;
    bellSchedulePeriodId;
    bellScheduleId;
}
exports.BellSchedulePeriodTimeCreateDto = BellSchedulePeriodTimeCreateDto;
__decorate([
    (0, class_validator_1.IsString)({ message: 'Start time cannot be blank' }),
    (0, is_valid_time_decorator_1.ValidTime)(),
    __metadata("design:type", String)
], BellSchedulePeriodTimeCreateDto.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.IsString)({ message: 'End time cannot be blank' }),
    (0, is_valid_time_range_decorator_1.TimeRange)('start', {
        message: 'End time must be after start time.'
    }),
    __metadata("design:type", String)
], BellSchedulePeriodTimeCreateDto.prototype, "end", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({}, { message: 'You must select a period.' }),
    __metadata("design:type", Number)
], BellSchedulePeriodTimeCreateDto.prototype, "bellSchedulePeriodId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({}, { message: 'You must select a bell schedule.' }),
    __metadata("design:type", Number)
], BellSchedulePeriodTimeCreateDto.prototype, "bellScheduleId", void 0);
